<template>
  <div class="title_box clearfix">
    <div class="title left">
      <span class="border"></span>
      <span class="bold">{{ title }}</span>
      <span class="tip">{{ tip }}</span>
    </div>
    <div class="right">
      <slot name="right" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Title",
  props: {
    title: {
      type: String,
      default: "我是默认标题"
    },
    tip: String
  }
};
</script>

<style lang="less" scoped>
.title_box {
  padding-top: 10px;
  padding-bottom: 10px;
  .title {
    .bold {
      font-weight: bold;
      font-size: 18px;
    }
    .border {
      display: inline-block;
      width: 5px;
      height: 20px;
      margin-right: 5px;
      background: #c04a45;
      border-radius: 4px;
      vertical-align: middle;
      margin-top: -4px;
    }
    .tip {
      // color: #ccc;
      font-size: 12px;
      margin-left: 10px;
    }
  }
}
</style>
